import React from 'react';
import {Button, Col, Divider, Image, Layout, Menu, Row} from 'antd';
import {SettingOutlined, TeamOutlined, UserOutlined, LeftCircleTwoTone} from '@ant-design/icons';
import {useLocation, useNavigate} from 'react-router-dom';
import {big_reverse_logo, short_reverse_logo} from '../../Config/Images';
import {useLayoutDispatch, useLayoutState} from '../../Context/LayoutProvider/LayoutProvider';
import {setContextCollapsed} from '../../Context/LayoutProvider/LayoutProviderActions';
import {MenuInfo} from "rc-menu/lib/interface";


interface MenuItem {
    key: string;
    icon?: React.ReactNode;
    label: React.ReactNode;
    disabled?: boolean;
}

function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    disabled = false,
    children?: MenuItem[],
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        disabled,
    } as MenuItem;
}

interface ViewProps {
    disableOtherItems?: boolean;
}

export const DiazarSider: React.FunctionComponent<ViewProps> = (props) => {
    const { disableOtherItems} = props;

    const {collapsed} = useLayoutState();
    const dispatch = useLayoutDispatch();

    const navigate = useNavigate();
    const location = useLocation();

    const items: MenuItem[] = React.useMemo( ()=>{
        return [
            getItem('Gestión de Usuarios', '/gestion-usuarios', <UserOutlined />),
            getItem('Empresas, roles y Permisos', '/empresas-roles', <TeamOutlined />, disableOtherItems),
            getItem('Auditoría y Seguridad', '/auditoria-seguridad', <TeamOutlined />, disableOtherItems),
            getItem('Configuración', '/configuracion', <SettingOutlined />, disableOtherItems),
        ];
    }, [disableOtherItems] );

    const selectedKeys = React.useMemo( ()=>{
        const keys: string[] = [];
        switch (location.pathname) {
            case '/':
            case '/migration/table':
                keys.push('/gestion-usuarios');
                break;

            default:
                keys.push(location.pathname);
                break;
        }

        return keys;
    }, [location] );

    const BtnCollapse = React.useMemo( ()=>{
        const imageLogo = collapsed ?  short_reverse_logo : big_reverse_logo;
        return (
            <Row className="header-sider">
                <Col xs={23} style={{overflow:'hidden'}}>
                    <Image src={imageLogo} alt="Diazar Logo" preview={false} className='diazar-logo'/>
                </Col>

                <Col xs={1}>
                    <Button className={`collapse-icon${ collapsed ? ' collapsed': '' }`} type="link" onClick={() => setContextCollapsed(dispatch)} icon={<LeftCircleTwoTone/>}/>
                </Col>
            </Row>
        );
    }, [collapsed, dispatch] );

    const clickHanddler = React.useCallback((event:MenuInfo)=>{
        switch (event.key){
            case '/gestion-usuarios':
                navigate('/');
                break;
            default:
                console.log(event);
                break;
        }
    }, [navigate]);

    return (
        <Layout.Sider //collapsible
            collapsed={collapsed}
            onCollapse={(_value) => setContextCollapsed(dispatch)}
                      breakpoint="lg"
                      width={300}
        >
            { BtnCollapse }
            <Menu theme="light"  mode="inline" items={items} defaultSelectedKeys={selectedKeys} onClick={clickHanddler}/>
            <Divider />
        </Layout.Sider>
    );
};
